import { render, staticRenderFns } from "./SchemeViewDialog.vue?vue&type=template&id=2928a386&scoped=true"
import script from "./SchemeViewDialog.vue?vue&type=script&lang=js"
export * from "./SchemeViewDialog.vue?vue&type=script&lang=js"
import style0 from "./SchemeViewDialog.vue?vue&type=style&index=0&id=2928a386&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2928a386",
  null
  
)

export default component.exports